import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#carrier #company_id			{ width: 10rem;		}
			#carrier #id					{ width: 5rem; text-align: right;	}
			#carrier #type					{ width: 4rem;		}
			#carrier #nick					{ width: 28rem;		}
			#carrier #name					{ width: 28rem; 	}
			#carrier #email					{ width: 20rem;		}
			#carrier #cpf					{ width: 8rem;		}
			#carrier #cnpj					{ width: 10rem; 	}
			#carrier #ie					{ width: 8rem; 		}
			#carrier #ie_type				{ width: 10rem;		}
			#carrier #phone					{ width: 10rem;		}
			#carrier #address_street		{ width: 26rem;		}
			#carrier #address_number		{ width: 6rem;		}
			#carrier #address_complement	{ width: 15rem;		}
			#carrier #address_district		{ width: 20rem;		}
			#carrier #address_state			{ width: 3.5rem;	}
			#carrier #address_city_id		{ width: 17rem;		}
			#carrier #address_zipcode		{ width: 6rem;		}
		</style>
		<form id="carrier" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="person_types">
			</datalist>
			<datalist id="ie_types">
			</datalist>
			<datalist id="states">
			</datalist>
			<datalist id="cities">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador do transportador">Transp
					<input id="id" type="text" disabled>
				</label>
				<label title="Tipo de personalidade jurídica">Tipo<sup>*</sup>
					<input id="type" type="text" list="person_types" required>
				</label>
				<label title="Nome curto do transportador">Apelido<sup>*</sup>
					<input id="nick" type="text" required>
				</label>
			</div>
			<div class="fsb">
				<label title="Nome ou razão social">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb" id="local_delivery_row">
				<label title="Cadastro simplificado para local de entrega (ex.: departamento)">Modo local de entrega
					<input id="is_local_delivery" type="checkbox" title="Desabilita CPF, CNPJ, IE e Tipo IE; usa Tipo LOCAL">
				</label>
			</div>
			<div class="fsb">
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
				<label title="Número do CPF">CPF
					<input id="cpf" type="text" placeholder="000.000.000-00">
				</label>
				<label title="Número do CNPJ">CNPJ
					<input id="cnpj" type="text" placeholder="00.000.000/0000-00">
				</label>
				<label title="Código da transportadora no ERP">Cód. ERP
					<input id="protheus_carrier_code" type="text" maxlength="32" placeholder="ex.: 15030">
				</label>
				<label title="Número da Inscrição Estadual">IE
					<input id="ie" type="text" placeholder="000.000.000.000">
				</label>
				<label title="Tipo de Inscrição Estadual">Tipo IE<sup>*</sup>
					<input id="ie_type" type="text" list="ie_types" required>
				</label>
			</div>
			<div class="fsb">
				<input type="hidden" id="address_id">
				<label title="Nome da rua ou avenida">Logradouro
					<input id="address_street" type="text">
				</label>
				<label title="Número">Número
					<input id="address_number" type="text">
				</label>
				<label title="Complemento">Complemento
					<input id="address_complement" type="text">
				</label>
			</div>
			<div class="fsb">
				<label title="Bairro">Bairro
					<input id="address_district" type="text">
				</label>
				<label title="Unidade Federativa">UF
					<input id="address_state" type="text" list="states">
				</label>
				<label title="Município">Município
					<input id="address_city_id" type="text" list="cities">
				</label>
				<label title="CEP">CEP
					<input id="address_zipcode" type="text" placeholder="00000-000">
				</label>
			</div>
			<div class="fsb">
				<span class="cep-hint" style="font-size:0.85em;color:var(--color-muted,#666);">Digite o CEP e saia do campo para preencher automaticamente (logradouro, bairro, UF, município).</span>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#carrier',
		/** Submit autocontido: lê DOM, valida e chama callback. Não usa formCheck/getValues do formset (evita impacto no resto do sistema). */
		submitHandler(formset, ev)
		{
			ev?.preventDefault();
			const root = document.querySelector('#carrier');
			if (!root) return;
			const val = (id) => (root.querySelector(`#${id}`)?.value ?? '').trim();
			const chk = root.querySelector('#is_local_delivery');
			const isLocal = !!chk?.checked;
			let typeRaw = (root.querySelector('#type')?.value ?? '').trim().toUpperCase();
			// API espera um caractere: J (PJ), F (PF), G (OP), L (LOCAL)
			const typeMap = { 'PJ': 'J', 'PF': 'F', 'G': 'G', 'GV': 'G', 'OP': 'G', 'L': 'L', 'LOCAL': 'L' };
			const type = isLocal ? 'L' : (typeMap[typeRaw] || typeRaw);
			// API espera ie_type como char: 1=Contribuinte, 2=Isento, 9=Não Contribuinte
			let ieTypeRaw = val('ie_type');
			const ieTypeNorm = (s) => (s || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
			const ieTypeMap = { 'CONTRIBUINTE': '1', 'ISENTO': '2', 'NAO CONTRIBUINTE': '9' };
			const ieType = isLocal ? '' : (ieTypeMap[ieTypeNorm(ieTypeRaw)] || (/^[129]$/.test(ieTypeRaw) ? ieTypeRaw : ieTypeRaw));
			// Telefone / CPF / CNPJ: enviar store (sem máscara), não o valor da tela
			const phoneRaw = val('phone');
			const phone = phoneRaw ? phoneRaw.replace(/[\(\)\-\s.]/g, '') : '';
			const cpf = val('cpf').replace(/[.\-\s]/g, '');
			const cnpj = val('cnpj').replace(/[.\-\/\s]/g, '');
			const data = {
				company_id: val('company_id'),
				id: val('id'),
				type,
				nick: val('nick'),
				name: val('name'),
				email: val('email'),
				phone,
				cpf,
				cnpj,
				protheus_carrier_code: val('protheus_carrier_code') || null,
				ie: val('ie'),
				ie_type: ieType,
				address_id: val('address_id'),
				address_street: val('address_street'),
				address_number: val('address_number'),
				address_complement: val('address_complement'),
				address_district: val('address_district'),
				address_state: val('address_state'),
				address_city_id: val('address_city_id'),
				address_zipcode: val('address_zipcode'),
				is_local_delivery: isLocal,
			};
			if (!data.company_id) throw new Error('Verificar Empresa*');
			if (!data.type) throw new Error('Verificar Tipo*');
			if (!data.nick) throw new Error('Verificar Apelido*');
			if (!data.name) throw new Error('Verificar Nome*');
			if (!isLocal && !/^[129]$/.test(data.ie_type)) throw new Error('Verificar Tipo IE*');
			formset.callback?.call(formset, data);
		},
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
			const sel = formset.form.selector;
			const chk = document.querySelector(`${sel} #is_local_delivery`);
			const typeEl = document.querySelector(`${sel} #type`);
			const cpfEl = document.querySelector(`${sel} #cpf`);
			const cnpjEl = document.querySelector(`${sel} #cnpj`);
			const ieEl = document.querySelector(`${sel} #ie`);
			const ieTypeEl = document.querySelector(`${sel} #ie_type`);
				const toggleLocal = () => {
				if (!chk) return;
				const on = chk.checked;
				const type = (typeEl?.value || '').trim().toUpperCase();
				if (on) {
					[cpfEl, cnpjEl, ieEl, ieTypeEl].forEach(el => {
						if (el) { el.disabled = true; el.required = false; el.value = ''; }
					});
					if (typeEl) { typeEl.value = 'L'; typeEl.disabled = true; }
				} else {
					if (typeEl) typeEl.disabled = false;
					// PJ/G: exige CNPJ e IE; PF: exige CPF; não exigir CPF para PJ
					const isPF = type === 'F';
					const isPJ = type === 'J' || type === 'G';
					if (cpfEl)  { cpfEl.disabled = !isPF;  cpfEl.required = isPF;  if (!isPF) cpfEl.value = ''; }
					if (cnpjEl) { cnpjEl.disabled = isPF;   cnpjEl.required = isPJ; if (isPF) cnpjEl.value = ''; }
					if (ieEl)   { ieEl.disabled = false;   ieEl.required = true; }
					if (ieTypeEl) { ieTypeEl.disabled = false; ieTypeEl.required = true; }
				}
			};
			chk?.addEventListener('change', toggleLocal);
			// Atualiza o valor armazenado do campo checkbox quando alteramos chk.checked no código (sem disparar 'change')
			const syncCheckboxStorage = () => {
				const field = formset.form.getFieldBySelector?.('#is_local_delivery');
				if (field && typeof field.setValue === 'function') field.setValue(chk?.checked ? 1 : 0);
			};
			formset.subscribe && formset.subscribe(['open'], () => {
				setTimeout(() => {
					// Só marcar "Modo local" se o tipo for L; caso contrário desmarcar (ex.: novo registro ou PJ)
					const type = (typeEl?.value || '').trim().toUpperCase();
					if (type === 'L') chk.checked = true;
					else chk.checked = false;
					syncCheckboxStorage();
					toggleLocal();
				}, 0);
			});
			// Ao mudar o tipo: se escolheu PJ/PF/G, desmarcar "Modo local" e atualizar valor armazenado
			typeEl?.addEventListener('change', () => {
				const type = (typeEl?.value || '').trim().toUpperCase();
				if (type && type !== 'L' && chk) {
					chk.checked = false;
					syncCheckboxStorage();
				}
				toggleLocal();
			});
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#type' }, types: [types.opt_person_type(), types.datalist()] },
		{ properties: { selector: '#nick' }, types: [types.name()] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#cpf' }, types: [types.cpf()] },
		{ properties: { selector: '#cnpj' }, types: [types.cnpj()] },
		{ properties: { selector: '#ie' }, types: [types.ie()] },
		{ properties: { selector: '#ie_type' }, types: [types.opt_ie_type(), types.datalist()] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#email' }, types: [types.email()] },
		{ properties: { selector: '#protheus_carrier_code' }, types: [] },
		{ properties: { selector: '#address_id' }, types: [] },
		{ properties: { selector: '#address_street' }, types: [types.name()] },
		{ properties: { selector: '#address_number' }, types: [types.name()] },
		{ properties: { selector: '#address_complement' }, types: [types.name()] },
		{ properties: { selector: '#address_district' }, types: [types.name()] },
		{ properties: { selector: '#address_state' }, types: [types.pubsub(), types.opt_uf(), types.datalist()] },
		{ properties: { selector: '#address_city_id' }, types: [types.pubsub(), types.name(), types.observer('address_state'), types.obs_load_cities(), types.obs_filter_cities('address_state')] },
		{ properties: { selector: '#address_zipcode' }, types: [types.cep(), types.obs_cep()] },
		{ properties: { selector: '#is_local_delivery' }, types: [types.checkbox()] },
	]

};

